import React from 'react';

class CustomVariables extends React.Component {
  constructor(props) {
    super(props);
    this.handleVariables = this.handleVariables.bind(this);
    this.addVariable = this.addVariable.bind(this);
    this.deleteVariable = this.deleteVariable.bind(this);
    this.handleSaveVariables = this.handleSaveVariables.bind(this);

    this.changeDebouncer = null;

    this.state = {
      variables: this.parseVariables(props.variables),
      updated: false,
      error: false
    };
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    this.setState({
      variables: this.parseVariables(next.variables),
      updated: false
    });
  }

  parseVariables(newVariables) {
    const variables = [];
    if (newVariables) {
      for (const key of Object.keys(newVariables)) {
        const value = newVariables[key];
        variables.push({
          key,
          value
        });
      }
    }

    return variables;
  }

  // Only keep numeric values (strip formating)
  parseValue(v) {
    return parseInt((`${v || 0}`).replace(/\D+/g, ''), 10);
  }

  // Replace whitespace with dash
  parseKey(k) {
    return k.replace(/\s/g, '-');
  }

  handleSaveVariables() {
    const stateVars = this.state.variables;
    let error = false;
    const newVariables = {};
    stateVars.forEach((pair, index) => {
      if (pair.key === '') {
        pair.key = index.toString();
      }
      const key = pair.key.trim();
      if (newVariables.hasOwnProperty(key)) {
        error = true;
      }
      // Make sure all are formated correct (even unchanged ones who have not gone throug the latest handleVariables)
      newVariables[key] = this.props.valueFormat ? this.props.valueFormat(pair.value) : this.parseValue(pair.value);
    });

    if (error) {
      this.setState({
        error: true
      });
    } else {
      const event = {
        target: {
          name: this.props.name,
          value: newVariables
        }
      };

      this.props.onSave(event);
    }
  }

  handleVariables(e) {
    const index = e.target.dataset.index;
    const field = e.target.name;
    let value = e.target.value;
    const stateVars = this.state.variables;

    if (field === 'key') {
      value = this.props.keyFormat ? this.props.keyFormat(value) : this.parseKey(value);
    } else {
      value = this.props.valueFormat ? this.props.valueFormat(value) : this.parseValue(value);
    }

    stateVars[index][field] = value;

    this.setState({
      variables: stateVars,
      updated: true,
      error: false
    });

    clearTimeout(this.changeDebouncer);
    this.changeDebouncer = setTimeout(() => {
      this.handleSaveVariables();
    }, 350);
  }

  addVariable() {
    const stateVars = this.state.variables;
    stateVars.push({
      key: '',
      value: ''
    });
    this.setState({
      variables: stateVars,
      updated: true,
      error: false
    });
  }

  deleteVariable(index) {
    index = parseInt(index, 10);
    const stateVars = this.state.variables;

    // Convert array of variables back to a a singe object with key/values for storing
    const newVariables = stateVars.filter((pair, i) => {
      return (i !== index);
    });

    this.setState({
      variables: newVariables,
      updated: true,
      error: false
    });

    clearTimeout(this.changeDebouncer);
    this.changeDebouncer = setTimeout(() => {
      this.handleSaveVariables();
    }, 350);
  }

  render() {
    let nameClass = 'mf-margin-bottom-5';
    let valueClass = 'mf-margin-bottom-5';

    if (this.props.nameAppend || this.props.namePrepend) {
      nameClass += ' input-group';
    }

    if (this.props.valueAppend || this.props.valuePrepend) {
      valueClass += ' input-group';
    }

    return (
      <div className="form-group">
        {this.state.variables.map((pair, index) => {
          return (
            <div className="row" key={`${this.state.variables.length}-${index}`}>
              {!this.props.indexed &&
                <div className="col-xs-5">
                  <div className={nameClass}>
                    {this.props.namePrepend && <div className="input-group-addon">{this.props.namePrepend}</div>}
                    <input
                      type="text"
                      className="form-control"
                      data-index={index}
                      name='key'
                      disabled={this.props.disabled}
                      value={pair.key}
                      onChange={(e) => this.handleVariables(e)}
                    />
                    {this.props.nameAppend && <div className="input-group-addon">{this.props.nameAppend}</div>}
                  </div>
                </div>
              }
              <div className="col-xs-5">
                <div className={valueClass}>
                  {this.props.valuePrepend && <div className="input-group-addon">{this.props.valuePrepend}</div>}
                  <input
                    type="text"
                    className="form-control text-right"
                    data-index={index}
                    disabled={this.props.disabled}
                    name='value'
                    value={pair.value}
                    onChange={(e) => this.handleVariables(e)}
                  />
                  {this.props.valueAppend && <div className="input-group-addon">{this.props.valueAppend}</div>}
                </div>
              </div>
              <div className="col-xs-2">
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={this.props.disabled}
                  title="Slett dette feltet"
                  onClick={(e) => this.deleteVariable(index, e)}
                >
                  <i className="fa fa-remove"></i>
                </button>
              </div>
            </div>
          );
        })}
        <button
          className="btn btn-default"
          type="button"
          disabled={this.props.disabled}
          onClick={() => this.addVariable()}
        >
          <i className="fa fa-plus" aria-hidden="true"></i> Nytt felt
        </button>
        &nbsp;
        {this.state.error &&
          <span className="text-danger"><i className="fa fa-exclamation-triangle"></i> Feil: To eller fler av feltene er like</span>
        }
      </div>
    );
  }
}

CustomVariables.defaultProps = {
  variables: {},
  onSave: () => {}
};

export default CustomVariables;
